import { timezoneUtils } from "@/lib/timezone";
import type { HolidayFormData } from "../types";

interface ExistingHoliday {
  name: string;
  startDateTime: string;
  endDateTime: string;
}

const normalizeName = (name: string) => name.trim().toLowerCase();

export function countMatchingHolidays(holidays: ExistingHoliday[], data: HolidayFormData) {
  const name = normalizeName(data.name);
  const start = data.startDateTime.toUnixInteger();
  const end = data.endDateTime.toUnixInteger();

  return holidays.filter(
    (holiday) =>
      normalizeName(holiday.name) === name &&
      timezoneUtils.fromISO(holiday.startDateTime).toUnixInteger() === start &&
      timezoneUtils.fromISO(holiday.endDateTime).toUnixInteger() === end
  ).length;
}
